"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const accounts_1 = require("companion-app-components/flux/accounts");
const investments_svg_1 = __importDefault(require("assets/zero-state-images/investments.svg"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const selectors_1 = require("companion-app-components/flux/investmentHoldingList/selectors");
const selectors_2 = require("companion-app-components/flux/investmentHoldings/selectors");
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const List_1 = __importDefault(require("@mui/material/List"));
const mui_1 = require("tss-react/mui");
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const utils_1 = require("utils/utils");
const helpers_1 = require("../helpers");
const index_1 = __importDefault(require("./HoldingRow/index"));
const styles_1 = __importDefault(require("./styles"));
// import { getLogger } from 'utils/logger';
// const log = getLogger('containers/OverviewPage/components/TopHoldings/index.js');
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const TopHoldings = (props) => {
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const topHoldings = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getTopHoldings)(state, Object.assign({ accountIds: null }, props)));
    const topHoldingSecurities = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getTopHoldings)(state, Object.assign({ accountIds: null, sortBy: 'security-change' }, props)));
    const allHoldings = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getHoldingListForAccountIds)(state, Object.assign({ accountIds: null, sortBy: 'ticker', sortOrder: 'ascending' }, props)));
    const isHoldingsLoading = (0, react_redux_1.useSelector)((state) => (0, selectors_2.getIsLoading)(state));
    const navigate = (0, react_router_1.useNavigate)();
    const { classes } = useStyles();
    const clickHolding = (e, accountId, securityId) => {
        e.stopPropagation();
        const url = `/investments?displayNode=${accountId}&securityID=${securityId}`;
        navigate(url);
    };
    const navigateToInvestmentsPage = () => {
        navigate('/investments?displayNode=INVESTMENT');
    };
    const { hasInvestmentAccounts, todaysInvestmentChangePercent } = props;
    const dataIsNull = () => isHoldingsLoading || topHoldings === null || topHoldingSecurities === null || allHoldings === null;
    const dataIsEmpty = () => !dataIsNull() && (topHoldings.size === 0 || topHoldingSecurities.size === 0 || allHoldings.size === 0);
    const noOp = () => { };
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts && hasInvestmentAccounts);
    // todo: after fixing render issues (props always invalid and always calling render), remove or move to trace
    // log.debug('ToMovers.render...', this.props);
    return (<div className={classes.root} role="presentation" style={{ padding: '20px', cursor: view === 'main' ? 'pointer' : 'auto' }} onClick={view === 'main' ? navigateToInvestmentsPage : noOp} onKeyPress={view === 'main' ? navigateToInvestmentsPage : noOp}>
      {view === 'loading' &&
            <LoadingView_1.default />}
      {view === 'zero' &&
            <ZeroStateView_1.default size="small" primary="No Accounts" icon={investments_svg_1.default} secondary={['Use a Quicken desktop application to add an ', <br key="br"/>, 'investment account, and then sync the account to Quicken web.']}/>}
      {view === 'empty' &&
            <ZeroStateView_1.default size="small" primary="No Top Movers" icon={investments_svg_1.default} secondary={['Either your holdings are unavailable/not set up ', <br key="br"/>, 'or today', <span key="quote">&rsquo;</span>, 's market data is not available at this time.']}/>}
      {view === 'main' && (todaysInvestmentChangePercent !== 0) &&
            <div className={classes.flexWrap}>
          <List_1.default disablePadding style={{ width: '50%', paddingRight: 20 }}>
            <div className={classes.sectionTitle}>BY SECURITY</div>
            <>
              {topHoldingSecurities.map((holding, i) => (<Fade_1.default key={holding.id} appear in>
                  <ListItem_1.default classes={{
                        dense: classes.listItemDense,
                    }} button divider={false} dense disableGutters style={{ transitionDelay: `${i * 0.05}s` }} onClick={(e) => clickHolding(e, holding.accountID, holding.id)} id={`ITM-SEC-${i}`}>
                    {!Number.isNaN(holding.valueChange) &&
                        <index_1.default holding={holding}/>}
                  </ListItem_1.default>
                </Fade_1.default>))}
            </>
          </List_1.default>
          <List_1.default disablePadding style={{ width: '50%', paddingLeft: 20 }}>
            <div className={classes.sectionTitle}>BY HOLDING</div>
            <>
              {topHoldings.map((holding, i) => (<Fade_1.default key={holding.id} appear in>
                  <ListItem_1.default classes={{
                        dense: classes.listItemDense,
                    }} button divider={false} dense disableGutters style={{ transitionDelay: `${i * 0.05}s` }} onClick={(e) => clickHolding(e, holding.accountID, holding.id)} id={`ITM-HOL-${i}`}>
                    {!Number.isNaN(holding.valueChange) &&
                        <index_1.default holding={holding} isByHoldingList/>}
                  </ListItem_1.default>
                </Fade_1.default>))}
            </>
          </List_1.default>
        </div>}
    </div>);
};
exports.default = TopHoldings;
